import { scrollToBottom } from '@/util/scrollToBorder';
import { createNamespacedHelpers } from 'vuex';
import dayjs from 'dayjs';

import ImagePreviewModal from '../ImagePreviewModal/ImagePreviewModal.vue';
import DateRangePicker from '@/components/shared/DateRangePicker/DateRangePicker.vue';
import SkeletonSpinner from '@/components/shared/SkeletonSpinner/SkeletonSpinner.vue';

import ImageService from '../../../services/image.service';
import ImageConst from '../../../constants/ImageConst';
import showToast from '@/util/toast';

const authMapper = createNamespacedHelpers('global/auth');

const modelMapper = createNamespacedHelpers('history/model');
const imageSelectionMapper = createNamespacedHelpers('imageSelection');
const imageSelectionImageMapper = createNamespacedHelpers('imageSelection/image');
const imageSelectionModelMapper = createNamespacedHelpers('imageSelection/model');
const globalMapper = createNamespacedHelpers('global');
const detectorMapper = createNamespacedHelpers('detector');
const detectorCameraMapper = createNamespacedHelpers('detector/camera');
const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');
const FIRST_INDEX = 0;
const DATE_START = 0;
const DATE_END = 1;
const SUFFIX = 'detector';
const KEY_ALLOW = 'allow_changing_model_when_selecting_image_from_cloud';

export default {
	name: 'ImageSelection',
	components: {
		DateRangePicker,
		ImagePreviewModal,
		SkeletonSpinner,
		ImageItem: () => import('../ImageItem/ImageItem.vue'),
	},

	props: {
		retrainModalId: String,
	},
	data() {
		return {
			ok: false,
			searchKey: '',
			imageSelectionModalId: 'imagePreviewModalId',
			selectedImageId: '',
			selected: 0,
			selectedModel: '',
			dummyModel: '',
			selectedImage: {},
			modalId: 'historyImageModal',
			suffix: SUFFIX,

			settingDefaultDate: 2,
			settingDateStart: 0,
			settingDateEnd: 1,

			acceptFileType: ImageConst.ACCEPT_FILE_TYPE.join(','),
		};
	},

	computed: {
		...imageSelectionMapper.mapState(['noCheckBox']),
		...modelMapper.mapState(['model']),
		// ...globalMapper.mapState(['advanceSetting']),
		...advancedSettingMapper.mapState(['advancedSetting']),

		quickRetainDisabled() {
			return (
				this.retrainingImages?.length === 0 ||
				this.model === 'holes_patchcore.pytorch' ||
				this.model === 'opencv_holes'
			);
		},
		...modelMapper.mapState(['models']),
		...authMapper.mapState(['username']),
		...imageSelectionImageMapper.mapState([
			'retrainingImages',
			'images',
			'noImage',
			'originImages',
			'allImagesCount',
			'skip',
			'dateStart',
			'dateEnd',
		]),
		...imageSelectionMapper.mapState(['noCheckBox']),

		isStopRetrieImageByScroll() {
			return this.images.length >= this.allImagesCount;
		},

		filterOptions() {
			return [
				{
					id: 1,
					sortType: this.$t('all'),
				},
				{
					id: 3,
					sortType: this.$t('filterOk'),
				},
				{
					id: 4,
					sortType: this.$t('filterNg'),
				},
			];
		},

		isSelected() {
			return Object.keys(this.selectedImage).length > 0;
		},
		isDisabledSelectModel() {
			console.log(this.advancedSetting);
			return !this.advancedSetting.detector?.find((i) => i.key === KEY_ALLOW)
				?.settingContent;
		},
	},

	watch: {
		selected(newSelected) {
			switch (newSelected) {
				case 0:
					this.sortImageByDate({
						username: this.username,
						modelName: this.dummyModel,
						dateStart: this.dateStart,
						dateEnd: this.dateEnd,
					});
					break;
				case 1:
					this.sortImageByDate({
						username: this.username,
						modelName: this.dummyModel,
						dateStart: this.dateStart,
						dateEnd: this.dateEnd,
					});
					break;

				default:
					break;
			}
		},

		models(models) {
			this.selectedModel = models[FIRST_INDEX]?.model_name;
		},

		async selectedModel(selectedModel) {
			await this.retrieveAllImages({
				username: this.username,
				modelName: selectedModel,
				dateStart: this.dateStart,
				dateEnd: this.dateEnd,
			});
			this.selected = 0;
			this.dummyModel = selectedModel;
			this.setModel({ model: selectedModel });
		},

		searchKey(searchKey) {
			this.sortImageByName({
				username: this.username,
				modelName: this.dummyModel,
				searchKey: searchKey,
			});
		},
	},

	methods: {
		...imageSelectionMapper.mapActions(['showFormModal', 'hideFormModal']),
		...imageSelectionMapper.mapMutations(['UPDATE_NO_CHECKBOX']),
		...globalMapper.mapMutations(['SET_SELECTED_IMAGE']),
		...detectorMapper.mapMutations([
			'SET_IMAGE_URI',
			'SET_SHOW_CAMERA',
			'SET_SHOW_CAMERA_IMG_BORDER',
			'SET_SELECTED_IMAGE',
			'SET_PREVIEW_IMAGE_DETECTION',
		]),
		...detectorCameraMapper.mapMutations(['SHOW_IMAGE_FROM_CLOUD']),
		...globalMapper.mapActions(['setSpinner']),
		...imageSelectionImageMapper.mapActions([
			'retrieveAllImages',
			'getImagesPaginated',
			'sortImageByDate',
			'sortImageByDateRevert',
			'filterImageByResultOK',
			'filterImageByResultNG',
			'sortImageByName',
			'retrain',
		]),
		...modelMapper.mapActions(['retrieveModels', 'setModel']),
		...imageSelectionMapper.mapMutations(['UPDATE_NO_CHECKBOX']),
		...imageSelectionImageMapper.mapMutations([
			'SET_DATE_START',
			'SET_DATE_END',
			'SET_IMAGES',
			'SET_NO_IMAGE',
		]),
		onClickListofRetraining() {
			this.ok = true;
			this.UPDATE_NO_CHECKBOX(false);
		},
		onClickListofImages() {
			this.ok = false;
			this.UPDATE_NO_CHECKBOX(true);
		},

		onChangeSelected(selectedImageId) {
			this.selectedImageId = selectedImageId;
		},

		onHidden() {
			this.UPDATE_NO_CHECKBOX(false);
			this.hideFormModal();

			this.$eventBus.$emit('force-update');
			this.$bvModal.hide(this.retrainModalId);
			const dateStart = dayjs(new Date())
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0)
				.format('YYYY/MM/DD HH:mm:ss');
			const dateEnd = dayjs(new Date())
				.set('hour', 23)
				.set('minute', 59)
				.set('second', 59)
				.format('YYYY/MM/DD HH:mm:ss');
			this.SET_DATE_START(dateStart);
			this.SET_DATE_END(dateEnd);
		},

		onHide() {
			this.SET_PREVIEW_IMAGE_DETECTION(false);
		},
		async onQuickRetrain() {
			await this.retrain();
			this.$eventBus.$emit('force-update');
		},


		startDetection() {
			// this.$eventBus.$emit('startDetectionFromSelectImage');

			this.$bvModal.hide(this.retrainModalId);
			this.SHOW_IMAGE_FROM_CLOUD(true);
			this.SET_SELECTED_IMAGE(this.selectedImage)
			this.SET_IMAGE_URI(this.selectedImage?.rawSizeImageURI);
			this.SET_SHOW_CAMERA(false);
			this.SET_SHOW_CAMERA_IMG_BORDER(false);
			setTimeout(() => {
				this.SET_PREVIEW_IMAGE_DETECTION(true);
			}, 300);
		},

		onCheckImage({ value, image }) {
			console.log({ value, image });
			this.selectedImage = image;
		},

		async shown() {

			this.handleScroll();

			let detectorSavedModel = localStorage.getItem(`${this.username}-${this.suffix}`);
			if (detectorSavedModel) {
				const imageIdx = this.models.findIndex(
					(item) => item.model_name === detectorSavedModel
				);
				this.selectedModel = this.models[imageIdx]?.model_name;
			} else {
				this.selectedModel = this.models[FIRST_INDEX]?.model_name;
			}

			const dateStarts =
				this.advancedSetting.detector[this.settingDefaultDate].settingContent[
					this.settingDateStart
				];
			const dateEnds =
				this.advancedSetting.detector[this.settingDefaultDate].settingContent[
					this.settingDateEnd
				];

			this.$store.commit('history/UPDATE_NO_CHECKBOX', true);

			this.SET_DATE_START(dateStarts);
			this.SET_DATE_END(dateEnds);

			await this.retrieveAllImages({
				username: this.username,
				modelName: this.selectedModel,
				dateStart: dateStarts,
				dateEnd: dateEnds,
			});
		},
		/**
		 * image click event handler
		 * @param {Object} imageData : choosen image's info
		 */
		onClickImage(imageData) {
			this.selectedImage = imageData;
			console.log('this.imageSelectionModalId: ', this.imageSelectionModalId);
			this.$bvModal.show(this.imageSelectionModalId);
		},

		/**
		 * Handle when imagelist scroll to right
		 */
		handleScroll() {
			const imageList = document.getElementById('imageCloud');
			const callback = async () => {
				if (this.isStopRetrieImageByScroll) return;
				this.setSpinner(true);
				try {
					await this.getImagesPaginated({
						username: this.username,
						modelName: this.dummyModel,
					});
				} catch (error) {
					console.log(error);
				}
				this.setSpinner(false);
			};

			scrollToBottom(imageList, callback);
		},

		/**
		 * filter date and time
		 * @param {Object} rangeDate: range date
		 */
		async onFilterDate(rangeDate) {
			const dateStart = dayjs(`${rangeDate[DATE_START]}`).format('YYYY/MM/DD');
			const dateEnd = dayjs(`${rangeDate[DATE_END]}`).format('YYYY/MM/DD');
			this.SET_DATE_START(dateStart + ' 00:00:00');
			this.SET_DATE_END(dateEnd + ' 23:59:59');
			await this.retrieveAllImages({
				username: this.username,
				modelName: this.selectedModel,
				dateStart: this.dateStart,
				dateEnd: this.dateEnd,
			});
		},

		eventBusListeners() {
			this.$eventBus.$on('force-update', () => {
				this.$forceUpdate();
			});
		},

		onUploadImage() {
			this.$refs.fileInput.click();
		},

		async handleImage(event) {
			let files = event.target.files;
			if (files.length === 0) {
				return;
			}

			if (
				ImageConst.MAX_FILE_SIZE != undefined &&
				files[ImageConst.IMAGE_SELECTED].size > ImageConst.MAX_FILE_SIZE * 1024 * 1024
			) {
				showToast({
					vueInstance: this,
					type: 'warning',
					message: this.$t('maxFileSize'),
				});
				return;
			}
			let reader = new FileReader();

			reader.onload = async (file) => {
				try {
					this.setSpinner(true);

					const file = files[ImageConst.IMAGE_SELECTED];
					let fileName = file.name;
					let fileType = file.type;

					if (!ImageConst.ACCEPT_FILE_TYPE.includes(fileType)) {
						showToast({
							vueInstance: this,
							type: 'warning',
							message: this.$t('fileTypeWarn'),
						});
						this.setSpinner(false);
						return;
					}

					let formData = new FormData();
					formData.append('content', file);
					formData.append('file_name', fileName);
					formData.append('user', this.username);
					formData.append('model_name', this.model);

					let dateEnd = dayjs(this.dateEnd).get('date');
					let createdAt = dayjs().set('date', dateEnd);
					formData.append('created_at', createdAt.unix());

					await ImageService.upload(formData);

					// Reload data
					await this.retrieveAllImages({
						username: this.username,
						modelName: this.selectedModel,
						dateStart: this.dateStart,
						dateEnd: this.dateEnd,
					});

					showToast({
						vueInstance: this,
						type: 'success',
						message: this.$t('uploadImageFromLocalSuccess'),
					});
					this.setSpinner(false);
				} catch (error) {
					this.setSpinner(false);
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('uploadImageFromLocalError'),
					});
					console.log(error);
				}
			};

			reader.readAsDataURL(files[ImageConst.IMAGE_SELECTED]);
		},
	},

	async mounted() {
		this.$store.commit('history/UPDATE_NO_CHECKBOX', true);
		this.SET_NO_IMAGE('');
		this.eventBusListeners();

		if (this.originImages?.length && !this.isRetrieveImages) return;

		this.setSpinner(true);

		// Avoid infinity spinner when failed to call API
		try {
			await this.retrieveModels({ username: this.username });
			this.setSpinner(false);
		} catch (error) {
			this.setSpinner(false);
			throw error;
		}
	},
};
